import { getLatestSubmissionNumber } from "helpers/submission";

export function normalizeQuoteRequest(value) {
  return value === true || value === "true";
}

export function buildSelectedPolicyDetails({
  selectedPolicy,
  values,
  companyInfo,
  accountInfo,
  user,
}) {
  const companyName =
    typeof values.company_filter === "string"
      ? values.company_filter
      : values.company_filter?.value ?? values.company_filter;
  const localPolicy = selectedPolicy?.data || {};
  const quoteRequest = normalizeQuoteRequest(values.quote_request);
  const fallbackCarrier = values.carrier || localPolicy.carrier || "Cover Whale";

  return {
    ...localPolicy,
    carrier: fallbackCarrier,
    company_id: companyInfo?.companyId || localPolicy.company_id || null,
    company_name: companyInfo?.companyName || localPolicy.company_name || companyName || "",
    insured_name:
      localPolicy.insured_name ||
      localPolicy.company_name ||
      companyInfo?.companyName ||
      companyName ||
      "",
    submission_number:
      getLatestSubmissionNumber(localPolicy) !== "N/A"
        ? getLatestSubmissionNumber(localPolicy)
        : values.policy,
    effective_date: localPolicy.effective_date || new Date(),
    quote_request: quoteRequest,
    account_name: accountInfo?.name || localPolicy.account_name || "",
    agent_email: accountInfo?.owner_email || user?.email || "",
  };
}

export function buildSchedulesFromPolicyData({
  submissionData,
  localQuote,
  currency,
  createId,
}) {
  const formattedVehiclesAndTrailers = [];
  const formattedDrivers = [];
  const liveDrivers = submissionData?.drivers || [];
  const localDrivers = localQuote?.drivers || [];

  if (liveDrivers.length > 0) {
    liveDrivers.forEach((item) => {
      formattedDrivers.push({
        id: item.id || createId(),
        Name: `${item.first_name} ${item.last_name}`,
        "Date Of Birth": item.date_of_birth,
        "DL #": item.driver_license_number,
      });
    });
  } else {
    localDrivers.forEach((item) => {
      formattedDrivers.push({
        id: item.id || createId(),
        Name: `${item.firstName} ${item.lastName}`,
        "Date Of Birth": item.dateOfBirth,
        "DL #": item.licenseNumber,
      });
    });
  }

  const liveVehicles = submissionData?.vehicles
    ? submissionData.vehicles.filter((veh) => veh.equipment_type === "Vehicle")
    : [];
  const localVehicles = localQuote?.vehicles || [];
  const liveTrailers = submissionData?.vehicles
    ? submissionData.vehicles.filter((veh) => veh.equipment_type === "Trailer")
    : [];
  const localTrailers = localQuote?.trailers || [];

  const appendScheduleItem = (item) => {
    const make = item.make || "";
    const model = item.model || "";

    formattedVehiclesAndTrailers.push({
      id: item.id || createId(),
      Year: item.year,
      Make: make.length > 15 ? make.slice(0, 12) + "..." : make,
      Model: model.length > 15 ? model.slice(0, 12) + "..." : model,
      VIN: item.vin,
      Value: currency.format(parseInt(item.value, 10) || 0),
    });
  };

  if (liveVehicles.length > 0) {
    liveVehicles.forEach(appendScheduleItem);
  } else {
    localVehicles.forEach(appendScheduleItem);
  }

  if (liveTrailers.length > 0) {
    liveTrailers.forEach(appendScheduleItem);
  } else {
    localTrailers.forEach(appendScheduleItem);
  }

  return {
    drivers: formattedDrivers,
    vehiclesAndTrailers: formattedVehiclesAndTrailers,
    usedLocalFallback:
      !submissionData ||
      (!liveDrivers.length && localDrivers.length > 0) ||
      ((!liveVehicles.length && localVehicles.length > 0) ||
        (!liveTrailers.length && localTrailers.length > 0)),
  };
}
